<template>
	<v-card class="mx-auto mt-2" :color="appointment.id == patientAppointment.id ? 'secondary' : ''">
		<v-list-item three-line @click="appointment.effective ? goToAppointment(appointment) : null" :style="!appointment.effective ? {opacity: 0.8} : {}">
			<v-list-item-content>
				<v-list-item-title class="primary--text">
					<v-row no-gutters class="text-body-1" align="center">
						<v-icon class="mr-1" small color="primary">mdi-account-tie</v-icon>
						<span class="mr-2">{{appointment.user.name}}</span>
						<v-icon class="mr-1" small color="primary">mdi-certificate</v-icon>
						<span>{{appointment.speciality.name}}</span>
						<v-spacer></v-spacer>
						<v-btn v-if="appointment.effective && appointment.id != patientAppointment.id && appointment.user_id == $store.getters.userId && !pdfMode" small color="secondary" depressed class="ma-2 primary--text">
							<translate>Enter</translate>
						</v-btn>
						<template v-if="!appointment.effective">
							<v-btn v-if="appointment.user_id == this.$store.getters.userId && !appointment.missed" @click="goToAppointment(appointment)" small color="secondary" depressed class="ma-2 primary--text">
								<translate>Start Appointment</translate>
							</v-btn>
							<v-btn v-if="appointment.user_id == this.$store.getters.userId && !appointment.missed" @click="missedOpen = true" small color="secondary" depressed class="ma-2 primary--text">
								<translate>Missed</translate>
							</v-btn>
							<template v-if="appointment.missed">
								<v-chip @click="missedOpen = true" class="mr-2" small key="missed"><translate>Missed</translate></v-chip>
							</template>
							<v-chip v-else class="mr-2" small key="scheduled"><translate>Scheduled</translate></v-chip>
							<v-dialog v-model="missedOpen" width="40%">
								<v-card>
									<v-card-title class="title primary--text mb-2 secondary">
										<translate>Missed Reason</translate>
									</v-card-title>
									<v-card-text>
										<v-textarea
											v-model="appointment.missed_reason"
											filled
											class="text-body-2"
											placeholder="..."
											auto-grow
											persistent-placeholder
											hide-details
										/>
									</v-card-text>
									<v-divider></v-divider>
									<v-card-actions>
										<v-btn color="secondary" class="primary--text" depressed @click="missedOpen = false">
											<translate key="cancel">Cancel</translate>
										</v-btn>
										<v-spacer></v-spacer>
										<v-btn v-if="appointment.missed" color="secondary" class="primary--text" depressed @click="appointmentMissed(false)">
											<translate key="remove-missed">Remove Missed</translate>
										</v-btn>
										<v-btn color="secondary" class="primary--text" depressed @click="appointmentMissed(true)">
											<translate v-if="appointment.missed" key="save">Save</translate>
											<translate v-else key="missed">Missed</translate>
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-dialog>
						</template>
						<v-icon class="mr-1" small color="primary">mdi-calendar</v-icon>
						<span class="mr-2">{{appointment.date}}</span>
						<v-icon class="mr-1" small color="primary">mdi-clock-outline</v-icon>
						<span>{{appointment.time}}</span>
					</v-row>
					<v-row no-gutters class="my-2 text-body-2">
						<template v-if="appointment.appointment_type">
							<v-icon class="mr-1" small color="primary">mdi-arrow-right-thin-circle-outline</v-icon>
							<span class="mr-2">{{appointment.appointment_type.name}}</span>
						</template>
						<template v-if="appointment.appointment_location">
							<v-icon class="mr-1" small color="primary">mdi-door</v-icon>
							<span class="mr-2">{{appointment.appointment_location.name}}</span>
						</template>
					</v-row>
				</v-list-item-title>
				<v-list-item-subtitle>
					{{appointment.description}}
				</v-list-item-subtitle>
			</v-list-item-content>
		</v-list-item>
		<v-divider v-if="appointment.effective || appointment.missed" class="mx-4"></v-divider>
		<v-card-text v-if="appointment.effective">
			<NewAppointmentForm
				v-if="editAppointment && appointment.id == patientAppointment.id"
				:edit="true"
				:appointment="appointment"
				@close-form="editAppointment = false"
				:patients="[patient]"
			/>
			<v-row no-gutters align="center">
				<v-icon small color="primary" class="mr-1">{{filterIcon}}</v-icon>
				<span class="text-subtitle-2">{{filterName}}</span>
				<v-spacer></v-spacer>
				<v-btn v-if="!pdfMode && false" small color="secondary" depressed class="ma-2 primary--text" @click="downloadPDF">
					<v-icon small class="mr-1">mdi-download</v-icon>
					<translate>PDF</translate>
				</v-btn>
				<v-btn-toggle v-if="!pdfMode" v-model="infoFilter" mandatory>
					<v-btn value="anamnesis" class="px-2" small :disabled="loading">
						<v-icon small color="primary">mdi-clipboard-alert</v-icon>
					</v-btn>
					<v-btn value="tests" class="px-2" small :disabled="loading" @click="getInfo('tests')">
						<v-icon small color="primary">mdi-chart-box</v-icon>
					</v-btn>
					<v-btn value="diagnosis" class="px-2" small :disabled="loading">
						<v-icon small color="primary">mdi-clipboard-check</v-icon>
					</v-btn>
					<v-btn value="treatments" class="px-2" small :disabled="loading" @click="getInfo('treatments')">
						<v-icon small color="primary">mdi-clipboard-text</v-icon>
					</v-btn>
				</v-btn-toggle>
			</v-row>
			<v-container fluid>
				<div v-if="infoFilter === 'anamnesis' || pdfMode">
					<ClinicHistoryAnamnesis :appointment="appointment" :appSymptoms="symptoms" :documents="documents" :importOption="false" />
				</div>
				<div v-if="infoFilter === 'tests' || pdfMode">
					<v-row v-if="pdfMode" class="my-2">
						<v-icon small color="primary" class="mr-1">mdi-chart-box</v-icon>
						<span class="text-subtitle-2" v-translate>Tests</span>
					</v-row>
					<ClinicHistoryTests :loading="loading" :appointment="appointment" :pdfMode="pdfMode" />
				</div>
				<div v-if="infoFilter === 'diagnosis' || pdfMode">
					<v-row v-if="pdfMode" class="my-2">
						<v-icon small color="primary" class="mr-1">mdi-clipboard-check</v-icon>
						<span class="text-subtitle-2" v-translate>Diagnosis</span>
					</v-row>
					<div
						v-if="appointment.diagnosis_general || appointment.diagnosis_mtc || symptoms['gen_diagnose'].length > 0 || symptoms['mtc_diagnose'].length > 0"
					>
						<ClinicHistoryTopic
							:title="$gettext('Biomedical')"
							:text="appointment.diagnosis_general"
							:chips="symptoms['gen_diagnose']"
						/>
						<ClinicHistoryTopic
							:title="$gettext('TCM')"
							:text="appointment.diagnosis_mtc"
							:chips="symptoms['mtc_diagnose']"
						/>
					</div>
					<p v-else class="font-weight-thin ml-2" v-translate key="no-diagnosis">No diagnosis.</p>
				</div>
				<div v-if="infoFilter === 'treatments'">
					<v-row v-if="pdfMode" class="my-2">
						<v-icon small color="primary" class="mr-1">mdi-clipboard-text</v-icon>
						<span class="text-subtitle-2" v-translate>Treatments</span>
					</v-row>
					<ClinicHistoryTreatments :loading="loading" :appointment="appointment" />
				</div>
			</v-container>
		</v-card-text>
		<v-card-text v-else-if="appointment.missed">
			<v-icon small color="primary" class="mr-1">mdi-account-remove</v-icon>
			<span class="font-weight-medium" v-translate>Missed Reason</span>:
			{{appointment.missed_reason}}
		</v-card-text>
		<template v-if="appointment.id == patientAppointment.id">
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn small color="primary" text @click="editAppointment = !editAppointment">
					<v-icon small color="primary" class="mr-1">mdi-pencil</v-icon>
					<translate>Edit</translate>
				</v-btn>
			</v-card-actions>
		</template>
	</v-card>
</template>

<script>
import NewAppointmentForm from "@/components/appointment/NewAppointmentForm.vue";
import ClinicHistoryTopic from "@/components/patient/ClinicHistoryTopic.vue";
import ClinicHistoryTreatments from "@/components/patient/ClinicHistoryTreatments.vue";
import ClinicHistoryTests from "@/components/patient/ClinicHistoryTests.vue";
import ClinicHistoryAnamnesis from '@/components/patient/ClinicHistoryAnamnesis.vue';
import axios from "axios";

export default {
	name: "ClinicHistoryItem",
	props: ["appointment", "patientAppointment", "documents", "patient", "pdfMode"],
	components: {
		NewAppointmentForm,
		ClinicHistoryTopic,
		ClinicHistoryTreatments,
		ClinicHistoryTests,
		ClinicHistoryAnamnesis
	},
	data: () => ({
		editAppointment: false,
		infoFilter: "anamnesis",
		testsTab: null,
		panel: 0,
		loading: false,
		missedOpen: false
	}),
	methods: {
		goToAppointment(appointment) {
			if (appointment.user_id == this.$store.getters.userId) {
				this.$emit('go-to-appointment', appointment.id);
			}
		},
		deleteAppointment() {
			this.$emit("delete-appointment", this.appointment);
		},
		changeFilter(value) {
			this.infoFilter = value;
		},
		getInfo(filter) {
			this.loading = true;
			axios
			.get("/patient/" + this.appointment.patient_id + "/appointment/" + this.appointment.id + "/history/" + filter)
			.then(response => {
				console.log(response.data);
				if(filter === 'tests') {
					this.appointment.tests = response.data.appointment.tests;
					this.appointment.custom_tests = response.data.appointment.custom_tests;
				} else {
					this.appointment.ashi_points = response.data.appointment.ashi_points;
					this.appointment.acu_points = response.data.appointment.acu_points;
					this.appointment.supplements = response.data.appointment.supplements;
					this.appointment.formulas = response.data.appointment.formulas;
					this.appointment.other_treatments = response.data.appointment.other_treatments;
					this.appointment.custom_treatments = response.data.appointment.custom_treatments;
				}
				this.loading = false;
			})
			.catch(error => {
				console.log(error);
				this.loading = false;
			});
		},
		appointmentMissed(value) {
			axios
				.post(`/patient/${this.patient.id}/appointment/${this.appointment.id}/missed`,
				{missed: value, missed_reason: this.appointment.missed_reason})
				.then(response => {
					if (response.data.result === 'ok') {
						this.missedOpen = false;
						this.appointment.missed = response.data.missed;
					}
				})
				.catch(error => console.log(error));
		},
		downloadPDF() {
			console.log("DOWNLOAD PDF");
		}
	},
	computed: {
		filterName() {
			if (this.infoFilter == "anamnesis") return this.$gettext("Anamnesis");
			else if (this.infoFilter == "tests") return this.$gettext("Tests");
			else if (this.infoFilter == "diagnosis")
				return this.$gettext("Diagnosis");
			else return this.$gettext("Treatments");
		},
		filterIcon() {
			if (this.infoFilter == "anamnesis") return "mdi-clipboard-alert";
			else if (this.infoFilter == "tests") return "mdi-chart-box";
			else if (this.infoFilter == "diagnosis") return "mdi-clipboard-check";
			else return "mdi-clipboard-text";
		},
		symptoms() {
			const symptoms = {};
			symptoms["chief_complaint"] = [];
			symptoms["history_illness"] = [];
			symptoms["past_medical"] = [];
			symptoms["family_history"] = [];
			symptoms["life_habits"] = [];
			symptoms["comparative_assessment"] = [];
			symptoms["review_systems"] = [];
			symptoms["gen_diagnose"] = [];
			symptoms["mtc_diagnose"] = [];
			this.appointment.symptoms.forEach(s => {
				symptoms[s.type].push(s);
			});
			return symptoms;
		}
	}
};
</script>

<style scoped>
.v-chip {
	background-color: "#f2f2f2";
}
>>> .theme--light.v-chip:not(.v-chip--active) {
	background: "#f2f2f2";
}
.text-treatment {
	max-height: 150px;
	overflow-y: auto;
}
>>> .v-window__prev,
.v-window__next {
	margin: 0 -10px;
}
>>> .v-window__next {
	margin: 0 -10px;
}
.v-btn:not(.v-btn--round).v-size--small {
	height: 28px;
	min-width: 0px;
}
</style>